import React from 'react'

const ReadIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11" fill="none">
            <path d="M8.51281 5.65288C8.51281 6.76581 7.61347 7.66515 6.50054 7.66515C5.38761 7.66515 4.48828 6.76581 4.48828 5.65288C4.48828 4.53995 5.38761 3.64062 6.50054 3.64062C7.61347 3.64062 8.51281 4.53995 8.51281 5.65288Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.49999 10.3025C8.48415 10.3025 10.3334 9.13338 11.6206 7.10987C12.1265 6.31733 12.1265 4.98518 11.6206 4.19265C10.3334 2.16914 8.48415 1 6.49999 1C4.51585 1 2.66658 2.16914 1.37941 4.19265C0.873531 4.98518 0.873531 6.31733 1.37941 7.10987C2.66658 9.13338 4.51585 10.3025 6.49999 10.3025Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ReadIcon